import * as yup from 'yup';
import { ClientStatusType, SegmentType } from '../types';

export const createUpdateClientDialogSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  description: yup.string().label('Description'),
  externalId: yup.string().label('External ID'),
  users: yup.array().of(yup.string().required()).required().label('Users'),
  contractTerm: yup.string().nullable().label('Contract term'),
  leadBrewerId: yup.string().label('Lead Brewer'),
  status: yup.mixed<ClientStatusType>().oneOf(Object.values(ClientStatusType)).required().label('Status'),
  segment: yup.mixed<SegmentType>().oneOf(Object.values(SegmentType)).required().nullable().label('Segment')
});

export const updateClientDialogSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  description: yup.string().nullable().label('Description'),
  externalId: yup.string().nullable().label('External ID'),
  contractTerm: yup.string().nullable().label('Contract term'),
  users: yup.array().of(yup.string().required()).required().label('Users'),
  leadBrewerId: yup.string().label('Lead Brewer'),
  status: yup.mixed<ClientStatusType>().oneOf(Object.values(ClientStatusType)).required().label('Status'),
  segment: yup.mixed<SegmentType>().oneOf(Object.values(SegmentType)).nullable().label('Segment')
});
